module.exports = __webpack_public_path__ + "img/icons.4bb3a4b6.svg";